module.exports = __webpack_public_path__ + "static/media/abilities.2ba8c2fc.gif";